<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="item ? item.variavel : []"
            ref="RkmTable"
            sort-by="fator"
        >

            <template v-slot:cell(actions)="{ index, item }">

                <rkm-button
                    @click="$emit('handleAlter', index, item)"
                    color="primary"
                    title="Editar"
                    small
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click.stop="handleDestroy(item)"
                    color="danger"
                    title="Excluir"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

export default {
    computed:{
        validations() {
            return {
                valor: {max: 8},
            }
        },
        fields() {
            return [
                { key: 'fator', label: 'Variável', sortable: true },
                { key: 'ordem', label: 'Ordem', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        },
    },
    props: {
        data: { type: Object, required: true },
        item: { type: Object, required: true },
    },
    data: () => ({
        filter: null,
        sexoId: null,
    }),
    methods: {
        validate() {
            return this.$refs.Form.validate()
        },
        openModal() {
            this.$refs.Modal.open()
        },
        handleDestroy(item) {

            const objId = this.item.variavel.findIndex((obj => obj.id == item.id));

            const destroy = async () => this.item.variavel.splice(objId, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o registro?', destroy)
        },
    },
}
</script>